import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_s_btn = _resolveComponent("s-btn")!

  return (_openBlock(), _createBlock(_component_s_btn, {
    type: "icon",
    class: "s-btn--action s-btn--icon__gray",
    icon: "app:actions"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_q_menu, { class: "s-table__menu--action" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "menu")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}